import React from 'react';

import styles from './list.module.scss';
type ListProps = {
  title: string;
  list: { name: string; img: any }[];
  className?: string;
};

export const List: React.FC<ListProps> = ({ title, list, className }) => {
  return (
    <div className={className ? `${styles['container']} ${className}` : styles['container']}>
      {list.some((item) => !!item.name) && <p className={styles['title']}>{title}</p>}

      <div className={styles['items']}>
        {list.map(
          (item, i) =>
            item.name && (
              <div className={styles['item']} key={item.img + i}>
                {item.img}
                <div className={styles['text']}>{item.name}</div>
              </div>
            ),
        )}
      </div>
    </div>
  );
};
